/*
 * Copyright (C) America Móvil S.A.B de C.V - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Sergio Erik Madrigal Herrera <sergio.madrigal@ironbit.com.mx>, January 2020
 */

import React, { StatelessComponent } from 'react';
import cls from '../utils/classnames';
import { LIST, LIST_ITEM } from '../utils/classes';
import './_styles.scss';

export type ListItemVariant = 'error' | 'success' | 'default' | 'error-password';

export interface IListItem {
    text: string;
    variant?: ListItemVariant;
}

export interface IListProps {
    variant: string;
    items: IListItem[];
    isPassword?: boolean;
}

export const List: StatelessComponent<IListProps> = props => {
    const { items, isPassword } = props;
    return (
        <ul className={ isPassword ? cls(`${LIST_ITEM}-password`) :  LIST}>
            {items.map((item, index)=> (
                <li
                    key={index}
                    className={cls(LIST_ITEM, {[`${LIST_ITEM}-${item.variant}`]: Boolean(item.variant)
                    })}
                >
                    {item.text}
                </li>
            ))}
        </ul>
    );
};



// WEBPACK FOOTER //
// ./src/packages/components/lib/List/index.tsx